import { FunctionComponent, MouseEvent } from 'react'
import { RoundedButton } from '../../shared'
import { ConversationHistoryDrawer } from '../ConversationHistoryDrawer'
import { StatsConversation } from '../StatsConversation'
import { StatsDisclaimer } from '../StatsDisclaimer'
import { TooltipIconButton } from '../TooltipIconButton'
import { StatsChatPanelProps } from './StatsChatPanel.model'
import styles from './StatsChatPanel.module.scss'

export const StatsChatPanel: FunctionComponent<StatsChatPanelProps> = ({
  chat,
  headerStart,
  onHeaderMouseDown,
  consumeDrag,
}) => {
  // Comme la barre Dictée, tout l'en-tête déplace le widget, boutons compris :
  // le clic qui termine un déplacement est intercepté avant d'atteindre le bouton.
  const handleHeaderClickCapture = (event: MouseEvent) => {
    if (!consumeDrag()) return
    event.stopPropagation()
    event.preventDefault()
  }

  return (
    <div className={styles.panel}>
      <div
        className={styles.header}
        onMouseDown={onHeaderMouseDown}
        onClickCapture={handleHeaderClickCapture}
      >
        <div className={styles.headerStart}>{headerStart}</div>
        <div className={styles.sep} />
        <div className={styles.buttonGroup}>
          <RoundedButton
            label="Historique"
            icon="history"
            theme={chat.isHistoryOpen ? 'primary' : 'transparent-dark'}
            size="nano"
            onClick={() => chat.setIsHistoryOpen((isOpen) => !isOpen)}
            testId="button-stats_assistant-panel-history"
          />
          <RoundedButton
            label="Nouvelle"
            icon="add"
            theme="transparent-dark"
            size="nano"
            // Déjà sur une nouvelle analyse : rien à réinitialiser.
            disabled={chat.conversationUlid === null}
            onClick={chat.startNewConversation}
            testId="button-stats_assistant-panel-new"
          />
        </div>
        <div className={styles.spacer} />
        <div className={styles.sep} />
        <StatsDisclaimer />
        <div className={styles.sep} />
        <div className={styles.buttonGroup}>
          <TooltipIconButton
            icon="caret"
            rotate={180}
            label="Rabattre le panneau"
            onClick={chat.collapseAssistant}
            testId="button-stats_assistant-panel-collapse"
          />
          <TooltipIconButton
            icon="caret"
            label="Ouvrir en grand"
            onClick={() => chat.setIsExpanded(true)}
            testId="button-stats_assistant-panel-expand"
          />
        </div>
      </div>

      <div className={styles.body}>
        {chat.isHistoryOpen && (
          <ConversationHistoryDrawer
            activeUlid={chat.conversationUlid}
            onSelect={chat.selectConversation}
            onNewAnalysis={chat.startNewConversation}
            onClose={() => chat.setIsHistoryOpen(false)}
          />
        )}
        <StatsConversation chat={chat} compact onChartExpand={() => chat.setIsExpanded(true)} />
      </div>
    </div>
  )
}
